import { ObterDadosFormaPagamentoResposta } from "app/api/classes/OrcamentoApi"
import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import { IOrcamento } from "app/types/IOrcamento"
import { WindowMU } from "app/types/WindowMU"
import { tratamentoErroPadrao } from "../tratamentoErroPadrao"
import globalMU from "globalMU"
import { ErroDaApi } from "app/api/classes/ErroDaApi"

declare var window: WindowMU


export async function alterarFormaPagamento({
    codigoFormaPagamento, codigoTipoDocumento
}: {
    codigoFormaPagamento: number,
    codigoTipoDocumento: number
}): Promise<ObterDadosFormaPagamentoResposta> {
    var orcamentoAtualizado: IOrcamento;
    try { 

        orcamentoAtualizado = await microuniversoApi.Orcamento.atualizarFormaPagamento({
            codigoFormaPagamento,
            codigoTipoDocumento: codigoTipoDocumento,
            identificadorOrcamento: store.getState().orcamento.IdentificadorOrcamento,
            verificarPendenciaFormaDePagamento: store.getState().orcamento.VerificarPendenciaFormaDePagamento,
            valorOrcamento: store.getState().orcamento.ValorTotal
        })
        
    }
    catch (e) {
        tratamentoErroPadrao(e);
    }
    finally{
        globalMU.unblockUI();
    }       
    if (! orcamentoAtualizado || ((orcamentoAtualizado as ErroDaApi).Error && (orcamentoAtualizado as ErroDaApi).ErrorLevel == "Error"))
        return null
    
    const orcamentoLegado = window.orcamentoController.model

    orcamentoLegado.atualizar({
        ...orcamentoAtualizado,
        CodigoFormaPagamento: codigoFormaPagamento,
        CodigoTipoDocumento: codigoTipoDocumento
    } as IOrcamento, true, true)

    return await microuniversoApi.Orcamento.obterDadosFormaPagamento({
        identificadorOrcamento: store.getState().orcamento.IdentificadorOrcamento,
        codigoFormaPagamento: codigoFormaPagamento,
        codigoTipoDocumento: codigoTipoDocumento,
        valorOrcamento: store.getState().orcamento.ValorTotal,
        verificarPendenciaFormaDePagamento: store.getState().orcamento.VerificarPendenciaFormaDePagamento
    })
  
}
